/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 29.01.14
 * Time: 13:22
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { PerformanceMonitoringEnvTypeEnum } from "../../profiling/enum/PerformanceMonitoringEnvTypeEnum";
import { PerformanceMonitoringVO } from "../../profiling/vo/PerformanceMonitoringVO";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class PerformanceMonitoringLogLOFactory extends BasicLogObjectFactory {

    public static AVERAGE_MEASUREMENT_DATA: number = 40001;

    private static PERFORMANCE_MONITORING_LOG: number = 40;

    private static PARAM_FPS: string = "fps";
    private static PARAM_MAX_FPS: string = "maxFps";
    private static PARAM_TOTAL_MEMORY_USAGE: string = "totalMemoryUsageInMB";
    private static PARAM_PRIVATE_MEMORY_USAGE: string = "privateMemoryUsageInMB";
    private static PARAM_PERFORMANCE_CATEGORY: string = "performanceCategory";
    private static PARAM_USER_LEVEL: string = "userLevel";
    private static PARAM_DOWNLOAD_RATE: string = "downloadRateInKBs";
    private static PARAM_DOWNLOAD_CONTENT_AMOUNT_EXTERNAL: string = "downloadContentAmountExternal";
    private static PARAM_DOWNLOAD_CONTENT_AMOUNT_LOCAL: string = "downloadContentAmountLocal";
    private static PARAM_DOWNLOAD_CONTENT_SIZE_EXTERNAL: string = "downloadContentSizeExternalInKB";
    private static PARAM_DOWNLOAD_CONTENT_SIZE_LOCAL: string = "downloadContentSizeLocalInKB";
    private static PARAM_LOGIN_TIME: string = "loginTime";
    private static PARAM_SESSION_LENGTH_MS: string = "sessionLengthMs";

    private _averageMeasurementResults: PerformanceMonitoringVO;
    private _userLevel: number;
    private _performanceCategory: number;
    private _type: PerformanceMonitoringEnvTypeEnum;
    private _sessionLengthMs: number;

    constructor(
        subErrorId: number,
        averageMeasurementResults: PerformanceMonitoringVO,
        userLevel: number,
        performanceCategory: number,
        type: PerformanceMonitoringEnvTypeEnum,
        sessionLengthMs: number
    ) {
        super();

        this._subErrorId = subErrorId;
        this._averageMeasurementResults = averageMeasurementResults;
        this._userLevel = userLevel;
        this._performanceCategory = performanceCategory;
        this._type = type;
        this._sessionLengthMs = sessionLengthMs;
    }

    /**
     * puts all performance monitoring data to LogObject
     * mobile has more specific values
     * @return
     */
    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_TYPE, ExternalLoggingConstants.LOGGING_TYPE_LOG.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, PerformanceMonitoringLogLOFactory.PERFORMANCE_MONITORING_LOG.toString());

        lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_FPS, this._averageMeasurementResults.averageFPS.toString());
        lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_MAX_FPS, this._averageMeasurementResults.maxFps.toString());
        lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_TOTAL_MEMORY_USAGE, this._averageMeasurementResults.averageTotalMemoryUsageInMB.toString());
        lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_PRIVATE_MEMORY_USAGE, this._averageMeasurementResults.averagePrivateMemoryUsageInMB.toString());
        lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_USER_LEVEL, this._userLevel.toString());
        lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_SESSION_LENGTH_MS, this._sessionLengthMs.toString());

        if (this._type === PerformanceMonitoringEnvTypeEnum.Mobile) {
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_PERFORMANCE_CATEGORY, this._performanceCategory.toString());
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_DOWNLOAD_RATE, this._averageMeasurementResults.downloadRateInKBs.toString());
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_DOWNLOAD_CONTENT_AMOUNT_EXTERNAL, this._averageMeasurementResults.downloadContentAmountExternal.toString());
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_DOWNLOAD_CONTENT_AMOUNT_LOCAL, this._averageMeasurementResults.downloadContentAmountLocal.toString());
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_DOWNLOAD_CONTENT_SIZE_EXTERNAL, this._averageMeasurementResults.downloadContentSizeExternalInKB.toString());
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_DOWNLOAD_CONTENT_SIZE_LOCAL, this._averageMeasurementResults.downloadContentSizeLocalInKB.toString());
            lo.logData.set(PerformanceMonitoringLogLOFactory.PARAM_LOGIN_TIME, this._averageMeasurementResults.loginTime.toString());
        }

        return lo;
    }
}
